import { processSteps } from "../../../mocks/services";

export default function ProcessSection() {
  return (
    <section className="py-24 lg:py-32 bg-[#0B1829] relative overflow-hidden">
      {/* Background texture */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, transparent, transparent 50px, rgba(255,255,255,0.5) 50px, rgba(255,255,255,0.5) 51px)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">How It Works</p>
          <h2
            className="text-4xl lg:text-5xl font-black text-white mb-4"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            Our Simple Service Process
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto">
            Getting your plumbing or heating fixed should be stress-free. Here&apos;s exactly what to expect when you call Jerry&apos;s.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
          {processSteps.map((step, index) => (
            <div key={step.num} className="relative">
              {/* Connector */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%-12px)] w-full h-px bg-gradient-to-r from-[#E8500A]/50 to-[#E8500A]/10 z-0" />
              )}
              <div className="relative z-10">
                {/* Step number circle */}
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 relative">
                  <div className="absolute inset-0 rounded-full bg-[#E8500A]/10 border border-[#E8500A]/30" />
                  <div className="absolute inset-2 rounded-full bg-[#E8500A]/5" />
                  <span
                    className="font-black text-2xl text-[#E8500A] relative z-10"
                    style={{ fontFamily: "'Barlow', sans-serif" }}
                  >
                    {step.num}
                  </span>
                </div>

                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-gray-400`} />
                </div>

                <h3
                  className="font-black text-white text-center text-base mb-2"
                  style={{ fontFamily: "'Barlow', sans-serif" }}
                >
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed text-center">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:8178324968"
            className="flex items-center gap-2.5 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold px-8 py-4 rounded-lg text-base transition-all hover:scale-[1.02] whitespace-nowrap"
          >
            <i className="ri-phone-fill" />
            Start the Process — Call Now
          </a>
          <div className="flex items-center gap-3 text-gray-500 text-sm">
            <i className="ri-shield-check-line text-[#E8500A]" />
            Transparent pricing before any work begins
          </div>
        </div>
      </div>
    </section>
  );
}
